// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { UtilGetString, UtilGetStringAsync } from './types.generated'

const utilLocales = [
    'en-US',
    'bn-IN',
    'cs-CZ',
    'de-DE',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-IN',
    'es-ES',
    'es-MX',
    'es-US',
    'fr-CA',
    'fr-FR',
    'hi-IN',
    'it-IT',
    'ja-JP',
    'kn-IN',
    'ml-IN',
    'mr-IN',
    'nl-NL',
    'pa-IN',
    'pl-PL',
    'pt-BR',
    'ta-IN',
    'te-IN',
    'tr-TR',
    'zh-CN',
] as const
const utilBundle = i18nBundle('util/util', utilLocales)

export const getString: UtilGetString = utilBundle.getString
export const getStringAsync: UtilGetStringAsync = utilBundle.getStringAsync
